import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from '@mui/styles';
// import axios from 'axios';
import axios from "../utils/axiosConfig";
import { fetchMe } from "../utils/authService";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { WEB_URL, PRIVACY_POLICY_WEB_URL } from "../utils/constants";
import LoaderProcessing from "../components/LoaderProcessing";
import ahGreenDotLogo from "../images/assesshub_logo_green_dot.svg";
import SupportBot from "./SupportBot";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"By signing in, you agree to AssessHub's "}
      <Link color="inherit" href={PRIVACY_POLICY_WEB_URL} target="_blank">
        Privacy Policy
      </Link>{" "}
      {"."}
      <br /><br />
      {"Copyright © "}
      <Link color="inherit" href={WEB_URL}>
        AssessHub
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url('./../../v2/images/login-page.svg')",
    backgroundRepeat: "no-repeat",
    backgroundColor: theme?.palette?.mode === "dark" ? theme?.palette?.grey?.[900] : theme?.palette?.grey?.[50] || '#fafafa',
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    padding: theme?.spacing?.(8, 4) || '64px 32px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100%",
    boxSizing: "border-box",
    // Mobile responsive padding
    '@media (max-width: 600px)': {
      padding: '40px 20px',
    },
    '@media (max-width: 400px)': {
      padding: '24px 16px',
    },
  },
  avatar: {
    margin: theme?.spacing?.(1) || '8px',
    backgroundColor: theme?.palette?.secondary?.main || '#dc004e',
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    maxWidth: "400px",
    marginTop: theme?.spacing?.(3) || '24px',
    padding: '0 8px',
    boxSizing: 'border-box',
  },
  submit: {
    margin: theme?.spacing?.(3, 0, 2) || '24px 0 16px',
    minHeight: '48px', // Touch-friendly button height
    fontSize: '1rem',
  },
  logo: {
    maxWidth: "100%",
    width: "450px",
    maxHeight: "70px",
    objectFit: "contain",
    '@media (max-width: 400px)': {
      width: '280px',
      maxHeight: '50px',
    },
  },
}));

export default function SignInSide(props) {
  const classes = useStyles();
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let [errorMsg, setError] = useState("");
  const [showModel, setModelShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loginCheckModal, setLoginCheckModal] = useState(false);

  useEffect(() => {
    let routeURL = new URLSearchParams(window.location.search);
    let time = Number(routeURL.get("ref"));
    let objData = {
      email: routeURL.get("email") !== null ? atob(routeURL.get("email")) : null,
      password: "firstlogin",
    };

    let timeData = new Date(time).toLocaleDateString();

    let currentDate = new Date().toLocaleDateString();

    if (objData.email !== null && timeData === currentDate) {
      sessionStorage.setItem("loginEmail", objData.email.toLowerCase());
      axios
        .post("/login", {
          userName: objData.email.toLowerCase(),
          password: objData.password,
          regen: true,
        })
        .then(async (userData) => {
          setError("");
          if (userData.data.status === "SUCCESS" || userData.data.status === "Token Regenerate complete successfully") {
            await fetchMe();
            props.setUser(true);
          } else if (userData.data.status === "User Already logged in, logout to proceed further or contact support") {
            setModelShow(true);
          } else if (userData.data.message === "you are already logged in") {
            setLoginCheckModal(true);
          }
        })
        .catch((error) => {
          console.log(">error", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setModelShow(false);
    setLoginCheckModal(false);
  };

  const handleSession = () => {
    setError(props.forceLogout);
  };

  const handleReLogin = (event) => {
    setLoginCheckModal(false);
    handleSubmit(event, true);
  };

  var UserReLoginModal = () => {
    return (
      <Dialog
        PaperProps={{
          style: { borderRadius: "10px", textAlign: "center", maxWidth: "380px", width: "calc(100% - 32px)", margin: "16px" },
        }}
        open={loginCheckModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ textAlign: "center" }}>
          <h3 id="transition-modal-title" style={{ color: "#6f2981", marginBottom: "30px" }}>
            System Warning
          </h3>
        </div>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span>You are already logged in on another device, Would you like to login to this device and logout from other device ?</span>
          </DialogContentText>

          <div className="form-group">
            <ul className="list-inline btn-list">
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="btn btn-blue" onClick={handleReLogin}>
                  Yes
                </a>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="btn btn-blue" onClick={handleClose} autoFocus>
                  No
                </a>
              </li>
            </ul>
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  const handleSubmit = async (event, regen) => {
    setLoading(true);
    setError("");
    event.preventDefault();
    sessionStorage.setItem("loginEmail", email.toLowerCase());
    // In production: spread concurrent logins over 2s to prevent bcrypt thread-pool
    // saturation when all candidates log in simultaneously at exam start time.
    if (process.env.NODE_ENV === 'production') {
      await new Promise(r => setTimeout(r, Math.random() * 2000));
    }
    axios
      .post("/login", {
        userName: email.toLowerCase(),
        password,
        regen: regen,
      })
      .then(async (userData) => {
        setLoading(false);
        if (userData.data.remainingAttempts !== undefined) {
          setError(userData.data.remainingAttempts > 1 ?
            <span>Username or Password is incorrect.</span>
            :
            userData.data.remainingAttempts > 0 ?
              <span>One last attempt remaining !!<br />WARNING : Too many unsuccessful attempts can cause the account to lock out !!</span>
              :
              <span>This account is locked due to too many unsuccessful attempts. Please try again after {userData.data.timeRemaining} {userData.data.timeRemaining !== 1 ? "minutes" : "minute"}.</span>
          )
          return
        }
        if (userData.data.message === "you are already logged in") {
          setLoginCheckModal(true);
        } else if (userData.data.status === "SUCCESS" || userData.data.status === "Token Regenerate complete successfully") {
          await fetchMe();
          props.setUser(true);
        } else if (userData.data.status === "User Already logged in, logout to proceed further or contact support") {
          setModelShow(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(error.response?.data?.error);
      });
  };

  return (
    <>
      {" "}
      <UserReLoginModal />
      <Grid container component="main" id="main-body-two" className={classes.root} onLoad={handleSession}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            {/* <Avatar className={classes.avatar}>
            <LockOutlinedIcon /> */}
            <img className={`img-responsive center-block ${classes.logo}`} src={ahGreenDotLogo} alt="React Logo" />
            {/* </Avatar> */}
            {/* <Typography component="h1" variant="h5">
            Sign in
          </Typography> */}
            <Box
              sx={{
                maxWidth: "400px",
                width: "100%",
                mt: 2,
                mb: 1,
                p: 1.5,
                backgroundColor: "#f5f0fa",
                borderLeft: "3px solid #7b60b0",
                borderRadius: "4px",
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              <Typography variant="caption" sx={{ color: "#555", lineHeight: 1.4 }}>
                This platform uses strictly necessary cookies for secure login and assessment delivery. No tracking or marketing cookies are used.
              </Typography>
            </Box>
            <form className={classes.form} onSubmit={handleSubmit} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Username"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(event) => setEmail(event.target.value.toLowerCase())}
              />

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={(event) => setPassword(event.target.value)}
              />
              {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
              <Link href='/v2/user/forgot-password' style={{ textDecoration: "none" }}>
                <div style={{ width: "100%", textAlign: "right", marginBottom: "10px", color: "rgb(123,96,176)", cursor: "pointer" }}>
                  Forgot Password?
                </div>
              </Link>

              {!!errorMsg && <Typography style={{ color: "red" }}>{errorMsg}</Typography>}

              <Dialog
                PaperProps={{
                  style: { borderRadius: "10px", textAlign: "center", maxWidth: "380px", width: "calc(100% - 32px)", margin: "16px" },
                }}
                open={showModel}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <div style={{ textAlign: "center" }}>
                  <h3 id="transition-modal-title" style={{ color: "#6f2981", marginBottom: "30px" }}>
                    System Warning
                  </h3>
                </div>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <span>The session is active. Do you want to re-login to the system?</span>
                  </DialogContentText>

                  <div className="form-group">
                    <ul className="list-inline btn-list">
                      <li>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a href="#" className="btn btn-blue" onClick={handleReLogin}>
                          Yes
                        </a>
                      </li>
                      <li>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a href="#" className="btn btn-blue" onClick={handleClose} autoFocus>
                          No
                        </a>
                      </li>
                    </ul>
                  </div>
                </DialogContent>
              </Dialog>

              {loading ? (
                <div className="loaderProcess" style={{ margin: "24px 0px 16px" }}>
                  <LoaderProcessing />
                </div>
              ) : (
                <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                  Sign In
                </Button>
              )}
              {/* <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid> */}
              <br /><br /><br /><br />
              <Box mt={5}>
                <Copyright />
              </Box>
            </form>
          </div>
        </Grid>
      </Grid>
      <SupportBot />
    </>
  );
}
